import { GroupBox } from '@infotech-soe/erp-ui-kit';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ThemePreferencesPaneContainerProps } from './ThemePreferencesPaneContainer';
import { ThemeSelector } from './ThemeSelector';

export const messages = defineMessages({
  selectThemes: {
    id: 'core.preferencesDialog.theme',
    defaultMessage: 'Theme',
  },
});

const ThemePreferencesPane = ({
  theme,
  onChangeTheme,
}: ThemePreferencesPaneContainerProps): React.JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <GroupBox label={formatMessage(messages.selectThemes)}>
      <GroupBox.Content>
        <ThemeSelector theme={theme} onChangeTheme={onChangeTheme} />
      </GroupBox.Content>
    </GroupBox>
  );
};

export default ThemePreferencesPane;
